import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { HeaderProps } from "./types";
import {
  PropertyDefinition, PropertyMappingType,
} from "app/library/layout-builder";
import { getMenuDefinitions } from 'components/cms/definitions';

export class HeaderDefinitions extends CmsReactComponent<HeaderProps> {
  static defaultProps = {};

  static schemaName = "header";
  static schemaType = "navigation-component";

  static propertyDefinitions: PropertyDefinition[] = [
    {
      name: "contentTypeIds",
      text: "Aranacak İçerik Tipleri",
      mapping: {
        type: PropertyMappingType.ContentTypes
      }
    },
    ...getMenuDefinitions("menu1", "Menü"),
  ];

}
